// @ts-nocheck

import {
  selectBasketItems,
  selectBasketMode,
  selectBasketState,
} from '../../../selectors/basket/basketPrimary.selector';
import { type StateType } from '../../../states';
import { type BasketBoomState } from '../../../states/basket';
import { BasketModes } from '../../../types/basket';
import { type Selector } from '../../../types/selectors';
import { type BoomSkinId } from '../types/global';
import { type BoomStepId } from '../types/steps';

export const selectBasketBoomIsActive: Selector<boolean | null | undefined> = (state: StateType) => {
  const basketMode = selectBasketMode(state);
  const basketItems = selectBasketItems(state);
  const basket = selectBasketState(state);

  if (!basketItems) {
    return null;
  }

  const isModeSimple = basketMode === BasketModes.SIMPLE;
  const isModeCombined = basketMode === BasketModes.COMBINED;
  const isOneSimpleBet = isModeSimple && Object.keys(basketItems).length === 1;

  if (isOneSimpleBet) {
    const foundOddsId = Object.keys(basketItems)[0];
    return basketItems[foundOddsId]?.isBoomActive;
  }
  if (isModeSimple) {
    return !!Object.keys(basketItems).find((key) => basketItems[key].isBoomActive);
  }
  if (isModeCombined) {
    return basket.isBoomActive;
  }

  return null;
};

type SelectorPropsType = {
  itemId?: string | number;
  oddId?: string | number;
  oddsId?: string | number;
};

export const selectBasketBoomState: Selector<BasketBoomState | null | undefined> = (
  state: StateType,
  { itemId, oddId, oddsId }: SelectorPropsType = {},
) => {
  const propId = itemId ?? oddId ?? oddsId;

  const basketMode = selectBasketMode(state);
  const basketItems = selectBasketItems(state);
  const basket = selectBasketState(state);

  const isModeSimple = basketMode === BasketModes.SIMPLE;
  const isModeCombined = basketMode === BasketModes.COMBINED;
  const isOneSimpleBet = isModeSimple && Object.keys(basketItems).length === 1;

  if (isOneSimpleBet) {
    const foundOddsId = Object.keys(basketItems)[0];
    return basketItems[foundOddsId]?.boom;
  }
  if (isModeSimple) {
    return basketItems[`${propId ?? ''}`]?.boom;
  }
  if (isModeCombined) {
    return basket.boom;
  }

  return null;
};

export const selectBasketBoomStepId: Selector<BoomStepId | undefined> = (
  state: StateType,
  props: SelectorPropsType = {},
) => selectBasketBoomState(state, props)?.stepId;

export const selectBasketBoomSkinId: Selector<BoomSkinId | undefined> = (
  state: StateType,
  props: SelectorPropsType = {},
) => selectBasketBoomState(state, props)?.skinId;
